import { createTheme, type ThemeOptions } from '@mui/material/styles';
import { alpha } from '@mui/material';
import { muiComponentsSq } from '../i18n/mui-sq';

/**
 * Official colours of Partia Demokratike e Shqipërisë (docs/brand/party/README.md).
 * See docs/10-ui-guidelines.md#branding.
 */
export const BRAND = {
  /** Blu PD */
  blue: '#00529c',
  /** Gri PD */
  grey: '#6b7b84',
};

const shared: ThemeOptions = {
  shape: { borderRadius: 10 },
  typography: {
    fontFamily:
      '"Inter Variable", "Inter", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    h4: { fontWeight: 700, letterSpacing: '-0.02em' },
    h5: { fontWeight: 700, letterSpacing: '-0.01em' },
    h6: { fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiButton: { defaultProps: { disableElevation: true } },
    MuiPaper: { defaultProps: { elevation: 0 } },
    MuiCard: {
      defaultProps: { variant: 'outlined' },
    },
    MuiTextField: { defaultProps: { fullWidth: true } },
    // "Reduce motion" in Settings (lib/motion.ts): menus, dialogs and the sidebar appear
    // without sliding or fading, no click ripples or pulsing placeholders. Loading spinners
    // keep turning, since they tell that something is happening.
    MuiCssBaseline: {
      styleOverrides: {
        'html.pd-reduce-motion': { scrollBehavior: 'auto' },
        'html.pd-reduce-motion *, html.pd-reduce-motion *::before, html.pd-reduce-motion *::after':
          { transitionDuration: '0.01ms !important', transitionDelay: '0s !important' },
        'html.pd-reduce-motion .MuiTouchRipple-root, html.pd-reduce-motion .MuiSkeleton-root, html.pd-reduce-motion .MuiSkeleton-root::after':
          { animation: 'none !important' },
      },
    },
    ...muiComponentsSq,
  },
};

export const theme = createTheme({
  ...shared,
  cssVariables: { colorSchemeSelector: 'class' },
  colorSchemes: {
    light: {
      palette: {
        primary: { main: BRAND.blue },
        secondary: { main: BRAND.grey },
        // MUI's default info/warning/success tones fail WCAG AA contrast for text; these pass
        // 4.5:1 both as text on the page and as white text on a filled chip/button.
        info: { main: '#01579B' },
        warning: { main: '#A04500' },
        success: { main: '#1B5E20' },
        error: { main: '#B71C1C' },
        background: { default: '#F5F7FA', paper: '#FFFFFF' },
        divider: alpha('#0F172A', 0.1),
      },
    },
    dark: {
      palette: {
        // Lighter tints of the brand hues for legible contrast on dark surfaces (UI only; the
        // logo itself switches to its official white version).
        primary: { main: '#6FA8DC' },
        secondary: { main: '#A7B4BB' },
        background: { default: '#0B1220', paper: '#111A2B' },
      },
    },
  },
});
